import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Lots.frontend.types'

@Injectable({ providedIn: 'root' })
export class Lots_recommend_lot_creationService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { vendorLotId?: number, lotLookupCode?: string, vendorLotLookupCode?: string, materialId?: number, recommendVendorLotOnly: boolean, optimalInputs?: { shelfLifeSpan?: number }, controllerTypeId?: number }): Promise<{ lotId?: number, lotLookupCode?: string, vendorLotId?: number, vendorLotLookupCode?: string, vat?: string, errors?: string[], manufactureDate?: string, expirationDate?: string }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.recommendVendorLotOnly)) {
      missingRequiredInParams.push('\'recommendVendorLotOnly\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Lots/functions/recommend_lot_creation`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

